import {
  Grid,
  Typography,
  Dialog,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Pendingwarning } from './Marketplaceicons';
import { poppins400, poppins500 } from 'theme/common.style';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const Privateofferdetailslink = ({
  open,
  address,
  setViewPrivateOffer,
  setViewPrivateOfferlinkpopup,
}) => {
  const theme = useTheme();
  const history = useHistory();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={true}
      onClose={() => {
        setViewPrivateOfferlinkpopup(false);
        history.push({
          pathname: history.location.pathname,
          state: { privateofferprice: null },
        });
      }}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '95%' : '400px',
          boxShadow: '-4px 4px rgba(0, 0, 0, 0.09)', // fixed typo
          padding: matchessm ? '30px 20px' : '30px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid item xs={12}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
            }}
          >
            {address}&nbsp;&nbsp;
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          display={'flex'}
          alignItems={'center'}
          padding={'20px 0px'}
        >
          <Pendingwarning />
          <Typography
            sx={{
              ...poppins500,
              fontSize: matchessm ? '16px' : '24px',
              paddingLeft: '12px',
            }}
          >
            Private Offer details
          </Typography>
        </Grid>

        <Grid item textAlign={'left'}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchesmd ? '12px' : '16px',
              color: '#666666',
            }}
          >
            This Private Offer has expired or been withdrawn.
          </Typography>
        </Grid>

        <Grid item textAlign={'left'} marginTop={2}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchesmd ? '12px' : '16px',
              color: '#666666',
            }}
          >
            <span
              onClick={() => {
                setViewPrivateOfferlinkpopup(false);
                setViewPrivateOffer(true);
                history.push({
                  pathname: history.location.pathname,
                  state: { privateofferprice: null },
                });
              }}
              style={{
                color: '#4CA4D6',
                textDecoration: 'underline',
                cursor: 'pointer',
                fontWeight: 500,
                fontFamily: 'Poppins',
              }}
            >
              Click to view latest Private Offer.
            </span>
          </Typography>
        </Grid>

        <Grid item textAlign={'left'} marginTop={3}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchesmd ? '12px' : '16px',
              color: '#666666',
            }}
          ></Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Privateofferdetailslink;
